import { createRoot } from 'react-dom/client';

import App from 'src/components/app/App';

import 'core-js'; // CoreJS polyfills for IE 10/11
import './chartjsConfig';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(<App />);
